/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_TaglineInputs */

const en_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Chrome, Firefox, and Edge extensions, built to spec.`)
};

const ar_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافات Chrome و Firefox و Edge مخصصة، مبنية حسب المواصفات.`)
};

const bn_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার চাহিদা অনুযায়ী Chrome, Firefox ও Edge-এর কাস্টম এক্সটেনশন।`)
};

const de_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Chrome-, Firefox- und Edge-Erweiterungen, erstellt nach Spezifikation.`)
};

const es_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensiones personalizadas de Chrome, Firefox y Edge, creadas según las especificaciones.`)
};

const fr_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensions Chrome, Firefox et Edge personnalisées, conçues selon les spécifications.`)
};

const pt_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensões personalizadas do Chrome, Firefox e Edge, desenvolvidas de acordo com as especificações.`)
};

const zh_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义 Chrome、Firefox 和 Edge 扩展，按照规范构建。`)
};

const tr_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesifikasyonlara göre oluşturulmuş özel Chrome, Firefox ve Edge uzantıları.`)
};

const ru_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательские расширения Chrome, Firefox и Edge, созданные по спецификациям.`)
};

const pl_svc_browser_extensions_tagline = /** @type {(inputs: Svc_Browser_Extensions_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niestandardowe rozszerzenia Chrome, Firefox i Edge, opracowane zgodnie ze specyfikacją.`)
};

/**
* | output |
* | --- |
* | "Custom Chrome, Firefox, and Edge extensions, built to spec." |
*
* @param {Svc_Browser_Extensions_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_tagline = /** @type {((inputs?: Svc_Browser_Extensions_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_tagline(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_tagline(inputs)
	if (locale === "de") return de_svc_browser_extensions_tagline(inputs)
	if (locale === "es") return es_svc_browser_extensions_tagline(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_tagline(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_tagline(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_tagline(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_tagline(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_tagline(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_tagline(inputs)
	return en_svc_browser_extensions_tagline(inputs)
});
export { svc_browser_extensions_tagline as "svc_browser-extensions_tagline" }